export default "__VITE_ASSET__D1C3CnkP__"